import { isPresent } from "@estaly/ui";

export function isAdvisoryStepComplete(advisoryAnswer) {
  if (!advisoryAnswer || advisoryAnswer.wantsInsurance !== true) return false;

  const hasUsage = advisoryAnswer.usageType != null && advisoryAnswer.usageType !== "";
  const hasOffer = advisoryAnswer.offerType != null && advisoryAnswer.offerType !== "";
  const hasExisting = advisoryAnswer.hasExistingInsurance !== undefined && advisoryAnswer.hasExistingInsurance !== "";

  const reasonOk =
    advisoryAnswer.hasExistingInsurance !== true ||
    (advisoryAnswer.existingInsuranceReason != null &&
      advisoryAnswer.existingInsuranceReason !== "" &&
      (advisoryAnswer.existingInsuranceReason !== "other" ||
        (advisoryAnswer.existingInsuranceReasonOtherText != null &&
          String(advisoryAnswer.existingInsuranceReasonOtherText).trim() !== "")));

  const electronicDevicesValueOk =
    advisoryAnswer.offerType !== "connect_protection" ||
    (advisoryAnswer.electronicDevicesValue != null && advisoryAnswer.electronicDevicesValue !== "");

  return hasUsage && hasOffer && hasExisting && reasonOk && electronicDevicesValueOk;
}

export function isCustomerStepComplete(customer, address, advisoryAnswer) {
  const hasIdentity =
    isPresent(customer?.firstName) &&
    isPresent(customer?.lastName) &&
    isPresent(customer?.email) &&
    isPresent(customer?.phone);

  const hasAddress = isPresent(address?.address1) && isPresent(address?.city) && isPresent(address?.country);

  const isProfessional = advisoryAnswer?.usageType === "professional";

  if (isProfessional) {
    const hasProfessionalInfo =
      isPresent(customer?.sirenNumber) &&
      isPresent(customer?.companyName) &&
      isPresent(customer?.legalForm) &&
      isPresent(customer?.buyerRole);
    return hasIdentity && hasProfessionalInfo && hasAddress;
  }

  const hasBirthInfo =
    isPresent(customer?.birthDate) && isPresent(customer?.birthCity) && isPresent(customer?.birthCountry);

  return hasIdentity && hasBirthInfo && hasAddress;
}
